module.exports = __webpack_public_path__ + "8fe16c461d67dc3fcfcc2ec1d09afba2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/works-with/devices/samsung-gear.png
// module id = 1786
// module chunks = 1